import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
	// Actions Saga
	analiseBuscarPorAlertaId: ['alertaId', 'callback'],

	// Actions reducers
	analiseBuscarPorAlertaIdReducer: ['analise'],
});

export const INITIAL_STATE_VALUES = {
	responsavel: '',
	dataAcao: undefined,
	responsavelEmissao: '',
	dataHoraEmissao: undefined,
	registro: {
		fileField: null,
		dataAnalise: undefined,
		descricao: '',
		documento: undefined,
		horaAnalise: '--:--',
		origem: {
			id: 0,
			link: '',
			nome: '',
		},
		responsavel: {
			id: 0,
			nome: '',
		},
	},
	monitoramento: {
		id: 0,
		alertaId: 0,
		registroMonitoramento: [],
	},
};

const INITIAL_STATE = Immutable(Object.assign({}, INITIAL_STATE_VALUES));

const monitoramentoBuscarPorAlertaIdReducer = (state = INITIAL_STATE, action) => state.merge({
	responsavel: action.data.responsavel,
	dataAcao: action.data.dataAcao,
	responsavelEmissao: action.data.responsavelEmissao,
	dataHoraEmissao: action.data.dataHoraEmissao,
	monitoramento: { ...action.analise },
});

export default createReducer(INITIAL_STATE, {
	[Types.ANALISE_BUSCAR_POR_ALERTA_ID_REDUCER]: monitoramentoBuscarPorAlertaIdReducer,
});
